<template>
	<li class="py-1">
		<div class="flex items-center gap-x-1">
			<h3
				:class="{ 'font-normal text-right': add, 'font-semibold text-right': !add }"
				class="flex-auto truncate text-xs leading-6 text-gray-900"
			>
				{{ item.title }}
			</h3>
			<el-button
				v-show="remove"
				@click.native.prevent="onRemove"
				icon="el-icon-delete"
				type="danger"
				circle
				plain
				size="mini"
				class="flex-none"
			/>
			<el-button
				v-show="add"
				@click.native.prevent="onAdd"
				icon="el-icon-plus"
				type="success"
				circle
				plain
				size="mini"
				class="flex-none"
			/>
			<p
				:class="{ 'font-bold': add }"
				class="flex-none text-xs text-gray-500 text-right"
				style="min-width: 45px"
			>
				<span
					v-show="itemType === 'header'"
					:class="{
						'bg-purple-600': roundedPercentage > 100,
						'bg-green-600': roundedPercentage > 95,
						'bg-orange-600': roundedPercentage > 80,
						'bg-red-600': roundedPercentage > 0,
					}"
					class="rounded-full text-white p-1 mx-1"
				>
					{{ roundedPercentage ? roundedPercentage.toFixed(2) + '%' : '' }}
				</span>
				<span v-show="itemType !== 'header'">
					{{ roundedPercentage ? roundedPercentage.toFixed(2) + '%' : '' }}
				</span>
				{{ roundedHours }}h
			</p>
		</div>
	</li>
</template>
<script>
import { filter } from 'lodash-es';

export default {
	name: 'PlanningItem',
	props: {
		item: {
			type: Object,
			default: null,
		},
		month: {
			type: Object,
			default: null,
		},
		mode: {
			type: String,
			default: null,
		},
		itemType: {
			type: String,
			default: null,
		},
		add: {
			type: Boolean,
			default: false,
		},
		remove: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		estimatedWorkingHours() {
			if (!this.item.costCenterId) {
				return this.month.estimatedWorkingHours;
			}
			const costCenterId = this.item.costCenterId;
			const holidaysByCostCenter = filter(this.month.holidays, function (o) {
				return o.costCenterId === costCenterId;
			});
			return this.month.estimatedWorkingHours - holidaysByCostCenter.length * 8;
		},
		roundedHours() {
			return (Math.round(this.item.hours * 100) / 100).toFixed(2);
		},
		roundedPercentage() {
			if (this.mode === 'customer') {
				return null;
			}
			const hoursFactor = this.item.hoursFactor ?? 0;
			if (hoursFactor === 0) {
				return null;
			}
			return Math.round((this.item.hours / (hoursFactor * this.estimatedWorkingHours)) * 100);
		},
	},
	methods: {
		getTimeDescription() {
			const roundedHours = (Math.round(this.item.hours * 100) / 100).toFixed(2);
			if (this.mode === 'customer') {
				return roundedHours;
			} else {
				if (!this.item.hoursFactor) {
					this.item.hoursFactor = 0;
				}
				if (this.item.hoursFactor === 0) {
					return roundedHours;
				}
				const percentage = (
					Math.round(
						(this.item.hours / (this.item.hoursFactor * this.month.estimatedWorkingHours)) * 100,
					) / 100
				).toFixed(2);
				return percentage * 100 + '% (' + roundedHours + 'h)';
			}
		},
		onAdd() {
			this.$emit('onAdd');
		},
		onRemove() {
			this.$emit('onRemove');
		},
	},
};
</script>
<style></style>
